if (!customElements.get('lp-story-carousel')) {
  class LpStoryCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.lp-video-landing-story-behind__track');
      this.dots = Array.from(this.querySelectorAll('.lp-video-landing-story-behind__dot'));
      this.realCards = Array.from(this.querySelectorAll('.lp-video-landing-story-behind__card:not(.is-clone)'));
      this.allCards = Array.from(this.querySelectorAll('.lp-video-landing-story-behind__card'));
      if (!this.track || this.realCards.length < 2) return;

      this.hasClones = this.allCards.length > this.realCards.length;
      this.isTeleporting = false;

      // Defensive: ensure the carousel is revealed even if the inline
      // init didn't run (e.g. if the custom element was upgraded first
      // for some reason).
      this.classList.add('is-ready');

      this.updateActiveDot();

      let scrollTimeout = null;
      this.track.addEventListener(
        'scroll',
        () => {
          if (this.isTeleporting) return;
          this.updateActiveDot();
          if (this.hasClones) {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => this.handleScrollSettled(), 120);
          }
        },
        { passive: true }
      );

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.scrollToCard(this.realCards[index], true);
        });
      });
    }

    scrollToCard(card, smooth) {
      if (!card) return;
      const target = card.offsetLeft - (this.track.clientWidth - card.offsetWidth) / 2;
      this.track.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
    }

    getCenteredCardIndex() {
      const cards = this.allCards;
      const center = this.track.scrollLeft + this.track.clientWidth / 2;
      let closest = 0;
      let smallestDelta = Infinity;
      cards.forEach((card, i) => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const delta = Math.abs(cardCenter - center);
        if (delta < smallestDelta) {
          smallestDelta = delta;
          closest = i;
        }
      });
      return closest;
    }

    updateActiveDot() {
      const centered = this.getCenteredCardIndex();
      const realCount = this.realCards.length;
      // With a triple-set layout the cards repeat in order, so the real
      // index is simply (centered % realCount). When there are no clones
      // (desktop / single block) this also resolves correctly.
      const realIndex = realCount > 0 ? ((centered % realCount) + realCount) % realCount : 0;
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === realIndex);
      });
    }

    handleScrollSettled() {
      const realCount = this.realCards.length;
      const realStart = realCount; // index of first real card
      const realEnd = realCount * 2 - 1; // index of last real card
      const centered = this.getCenteredCardIndex();
      // If the centered card lives in a clone set, teleport (no
      // animation) to the matching real card so the user always has a
      // full set of clones to scroll into next.
      if (centered < realStart) {
        this.teleportToCard(this.allCards[centered + realCount]);
      } else if (centered > realEnd) {
        this.teleportToCard(this.allCards[centered - realCount]);
      }
    }

    teleportToCard(card) {
      this.isTeleporting = true;
      this.scrollToCard(card, false);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.isTeleporting = false;
          this.updateActiveDot();
        });
      });
    }
  }
  customElements.define('lp-story-carousel', LpStoryCarousel);
}
